module.exports = __webpack_public_path__ + "img/finance_banner.d8e4c1ab.png";